import React from "react";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import "../styles/index.scss";

function Layout({ children }) {
    return (
        <div>
            <Navbar />
            <main>
                {children}
            </main>
            <Outlet />
        </div>
    )
}

export default Layout;